'use strict';

var dialog = require('../../dialog');
var GoogleTagManagerClient = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/util/GoogleTagManagerClient');
var OrderConfirmation = require('../orderconfirmation');

exports.initialize = initialize;

var paymentsClient;
var paymentsClientHasDataChangedCallback;
var isReadyToPayResult;
var options = {};
var buffer = {};

var baseCardPaymentMethod = {
	type: 'CARD',
	parameters: {
		allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
		allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA']
	}
};

function initialize(optionsParameter) {
	options = optionsParameter || {};

	if (!$('.submit-googlepay').length) {
		// Server-side templates only render this container when enableGooglePay is on
		// and the DW_GOOGLE_PAY payment method is active - nothing to do otherwise.
		return;
	}

	if (options.isCartPage || options.isCheckoutPage) {
		// Bypass the debounce here - this is a single deterministic call on page
		// load, not a burst of rapid-fire events, so there's nothing to coalesce
		// and no reason to delay the button becoming usable.
		fetchGooglePayPaymentRequest();
	}
	$(document).off('GooglePay.GetPaymentRequest').on('GooglePay.GetPaymentRequest Cart.UpdateSuccess ProductDetailPage.Variant.Updated ProductDetailPage.AddToCartOptionsSelect ProductDetailPage.Bopis.AddToCart ProductDetailPage.Bopis.OptionsRedrawn', function(event, data) {
		// Variant/cart updates can re-render the purchase panel via AJAX, replacing
		// .google-pay-button-container with a fresh, empty element - unlike Apple's
		// <apple-pay-button> custom element, our button is created imperatively in JS
		// and needs to be re-injected whenever that happens.
		//
		// ProductDetailPage.Bopis.OptionsRedrawn specifically matters here: selecting a size can
		// narrow the fulfillment panel to a different option (e.g. Ship-to-Store only) via an
		// AJAX redraw (AddToCartOptions.js) with no guaranteed ordering against
		// ProductDetailPage.Variant.Updated - without reacting to the redraw's own completion,
		// the debounced re-fetch below could run before that redraw actually lands, reading the
		// fulfillment panel's pre-redraw (stale) selection.
		checkReadyToPay();
		getGooglePayPaymentRequest(data);
	});

	// pay.js (htmlhead.isml) loads async with no guaranteed timing against this script - on a cold
	// cache, checkReadyToPay() below can run before it's finished loading and silently give up (see
	// its own google.payments.api guard), leaving the button missing until some unrelated event
	// (e.g. a variant-selection event above) happens to retrigger the check. Re-running it once the
	// script itself finishes loading closes that gap without depending on the shopper doing
	// anything first - checkReadyToPay() already no-ops harmlessly if it resolved earlier.
	var googlePaySdkScript = document.querySelector('script[src="https://pay.google.com/gp/p/js/pay.js"]');
	if (googlePaySdkScript) {
		googlePaySdkScript.addEventListener('load', checkReadyToPay);
	}

	checkReadyToPay();
}

function getPdpPaymentRequestData(data) {
	if (!options.ProductId) {
		return data;
	}

	// ProductDetailPage.Bopis.AddToCart (store search / Local Delivery dialog) fires with a
	// handful of inconsistent payload shapes depending on which widget triggered it, none of
	// which carry ProductId/StoreId - re-derive both from the DOM instead, same as the GA4
	// tagging in onGooglePayButtonClicked and AddToCartOptions.js's own
	// ProductDetailPage.AddToCartOptionsSelect trigger. This has to happen at fetch time
	// (inside the debounce below), not when the triggering event first fires - the widgets
	// that fire this event update .selected-store via their own follow-up AJAX call, so
	// reading the DOM immediately on the event would still see the previous selection.
	return {
		ProductId: $('#pid').val(),
		StoreId: $('.bopis-add-to-cart-options-container .selected-store').attr('store-id')
	};
}

function needsPaymentDataChangedCallback() {
	var callbackIntents = buffer['paymentDataRequest'] && buffer['paymentDataRequest'].callbackIntents;
	if (!callbackIntents) {
		return false;
	}
	return ['SHIPPING_ADDRESS', 'SHIPPING_OPTION', 'OFFER', 'PAYMENT_METHOD'].some(function(intent) {
		return callbackIntents.indexOf(intent) !== -1;
	});
}

function getPaymentsClient() {
	// Google's SDK rejects onPaymentDataChanged being registered on a transaction whose
	// callbackIntents never actually trigger it (checkout-page / store-pickup-only requests,
	// which only need PAYMENT_AUTHORIZATION) - DEVELOPER_ERROR at loadPaymentData time. Since
	// the same button has to serve both kinds of request depending on what's currently
	// buffered, rebuild the client whenever that need changes instead of registering the
	// callback unconditionally on a single long-lived instance.
	var needsDataChangedCallback = needsPaymentDataChangedCallback();
	if (!paymentsClient || paymentsClientHasDataChangedCallback !== needsDataChangedCallback) {
		var paymentDataCallbacks = {
			onPaymentAuthorized: onPaymentAuthorized
		};
		if (needsDataChangedCallback) {
			paymentDataCallbacks.onPaymentDataChanged = onPaymentDataChanged;
		}
		paymentsClient = new google.payments.api.PaymentsClient({
			environment: $('.submit-googlepay').data('environment') || 'TEST',
			paymentDataCallbacks: paymentDataCallbacks
		});
		paymentsClientHasDataChangedCallback = needsDataChangedCallback;
	}
	return paymentsClient;
}

// Google Pay for Web doesn't officially support iOS or Safari - every iOS browser is a WebKit
// wrapper under Apple's rules (not just Safari itself), and Safari's engine (iOS or desktop
// macOS) lacks the underlying Payment Request API hooks Chrome relies on, so
// paymentsClient.isReadyToPay() can report a false positive there. Tapping the button then falls
// back to a top-level navigation to pay.google.com/gp/p/loading that fails with Google's own
// generic "Something went wrong," in a *new tab*, independent of anything our own click handler
// does - confirmed by reproducing it on Safari/iPhone with a valid size selected (ruling out our
// click-time size/color validation as the cause). Per Google's own documentation this isn't
// iOS-specific - desktop Safari hits the same Payment Request limitation - so both are gated
// here, not just iOS. Affected shoppers already have Apple Pay as a working wallet option.
var isIosDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function checkReadyToPay() {
	if (isIosDevice || isSafariBrowser) {
		isReadyToPayResult = false;
		applyReadyToPayResult(false);
		return;
	}

	if (!('google' in window) || !google.payments || !google.payments.api) {
		return;
	}

	if (isReadyToPayResult !== undefined) {
		// Device/browser capability doesn't change between variant selections -
		// just re-apply the cached answer to whatever DOM exists right now.
		applyReadyToPayResult(isReadyToPayResult);
		return;
	}

	getPaymentsClient().isReadyToPay({
		apiVersion: 2,
		apiVersionMinor: 0,
		allowedPaymentMethods: [baseCardPaymentMethod]
	})
	.then(function(response) {
		isReadyToPayResult = !!response.result;
		applyReadyToPayResult(isReadyToPayResult);
	})
	.catch(function(error) {
		console.error('GooglePay-isReadyToPay', error);
	});
}

function applyReadyToPayResult(isReady) {
	$('[payment-method-container="DW_GOOGLE_PAY"]').attr('can-make-payments', isReady);
	$('[payment-method-group-container="DW_GOOGLE_PAY"]').attr('can-make-payments', isReady);
	if (isReady) {
		renderButton();
	}
}

function renderButton() {
	// 4px everywhere (Checkout, Express, PDP) per Google's Google Pay UX review - matched across
	// all wallet buttons (and the PDP Add to Cart button) for visual consistency.
	var buttonRadius = 4;

	// A page can render this template more than once (e.g. PDP plus a Cart/Express
	// Checkout section), so this is a class, not an id - each empty instance gets
	// its own button element via a fresh createButton() call.
	$('.google-pay-button-container').each(function() {
		var $container = $(this);
		if ($container.children().length) {
			return;
		}

		var button = getPaymentsClient().createButton({
			onClick: onGooglePayButtonClicked,
			buttonType: 'plain',
			buttonSizeMode: 'fill',
			buttonRadius: buttonRadius
		});
		$container.append(button);
	});
}

function onGooglePayButtonClicked() {
	var isVariantSelected = true;
	if (options.ProductId) {
		var sizeSelected = $('div.product-variations .size.size-options li.selected');
		var lengthSelected = $('div.product-variations .length.length-options li.selected').length;
		var widthSelected = $('div.product-variations .width.width-options li.selected').length;
		var isSizeSelected = sizeSelected.length || (lengthSelected && widthSelected);

		if (!isSizeSelected) {
			dialog.open({
				html: 'Please select a size',
				options: {
					dialogClass: 'dialog-alert',
					draggable: false
				}
			});
			isVariantSelected = false;
		}

		if (!$('div.product-variations .color.color-options li.selected').length) {
			dialog.open({
				html: 'Please select a color',
				options: {
					dialogClass: 'dialog-alert',
					draggable: false
				}
			});
			isVariantSelected = false;
		}
	}

	if (!(options.isCartPage || options.isCheckoutPage || isVariantSelected)) {
		return;
	}

	if (pageContext && pageContext.options && pageContext.options.GoogleTagManager && pageContext.options.GoogleTagManager.EnableGoogleAnalytics4) {
		var googlePayEventData;
		var googlePayEventOptions;
		if (pageContext.type == 'product') {
			if (pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4 && pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items && pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items.length > 0) {
				googlePayEventData = {
					action_name: 'googlepay',
					action_page_type: 'PDP',
					action_value: pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items[0].price,
					action_items: [pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items[0].item_id]
				}
			}
		} else if (pageContext.type == 'cart') {
			googlePayEventData = {
				action_name: 'googlepay',
				action_page_type: 'Cart'
			}
			googlePayEventOptions = {
				DecorateDataLayerWithCartTotal: true,
				DecorateDataLayerWithCartTotalKey: 'action_value',
				DecorateDataLayerWithProductData: true,
				DecorateDataLayerWithProductDataKey: 'action_items'
			}
		} else if (pageContext.type == 'onepcheckout_groups') {
			googlePayEventData = {
				action_name: 'googlepay',
				action_page_type: 'Checkout'
			}
			googlePayEventOptions = {
				DecorateDataLayerWithCartTotal: true,
				DecorateDataLayerWithCartTotalKey: 'action_value',
				DecorateDataLayerWithProductData: true,
				DecorateDataLayerWithProductDataKey: 'action_items'
			}
		}
		if (googlePayEventData) {
			GoogleTagManagerClient.PushDataLayerForDataLayerType('Event', googlePayEventData, googlePayEventOptions);
		}
	}

	if (!buffer['paymentDataRequest']) {
		console.error('GooglePay-loadPaymentData', 'No paymentDataRequest available - GetRequest may have failed');
		dialog.open({
			html: 'Google Pay is temporarily unavailable. Please try again or use another payment method.',
			options: {
				dialogClass: 'dialog-alert',
				draggable: false
			}
		});
		return;
	}

	getPaymentsClient().loadPaymentData(buffer['paymentDataRequest'])
	.catch(function(error) {
		if (error.statusCode !== 'CANCELED') {
			console.error('GooglePay-loadPaymentData', error);
		}
		fetch(Urls.GooglePay.Cancel, getFetchOptions('POST'))
		.then(function() {
			if (options.isCheckoutPage) {
				$(document).trigger('Cart.Update');
			}
		})
		.catch(function(cancelError) {
			console.error('GooglePay-Cancel', cancelError);
		});
	});
}

function onPaymentDataChanged(intermediatePaymentData) {
	var url;
	if (intermediatePaymentData.callbackTrigger == 'SHIPPING_OPTION') {
		url = Urls.GooglePay.ShippingOptionChanged;
	} else if (intermediatePaymentData.callbackTrigger == 'SHIPPING_ADDRESS' || intermediatePaymentData.callbackTrigger == 'INITIALIZE') {
		// Google fires 'INITIALIZE' once, immediately on sheet open, for whatever
		// default address it pre-filled - same shippingAddress payload shape as
		// 'SHIPPING_ADDRESS', so it needs the same handling or shipping options
		// never get calculated for that default address and the sheet sticks on
		// "Shipping option pending" until the shopper manually changes it.
		url = Urls.GooglePay.ShippingAddressChanged;
	} else {
		return Promise.resolve({});
	}

	return fetch(url, getFetchOptions('POST', intermediatePaymentData))
	.then(function(response) {
		return response.json();
	})
	.catch(function(error) {
		console.error('GooglePay-PaymentDataChanged', error);
		return { error: { intent: intermediatePaymentData.callbackTrigger, reason: 'OTHER_ERROR', message: 'An unexpected error occurred.' } };
	});
}

function onPaymentAuthorized(paymentData) {
	return fetch(Urls.GooglePay.PaymentAuthorized, getFetchOptions('POST', paymentData))
	.then(function(response) {
		return response.json();
	})
	.then(function(response) {
		if (response.status != 'success') {
			return { transactionState: 'ERROR', error: { intent: 'PAYMENT_AUTHORIZATION', reason: 'PAYMENT_DATA_INVALID', message: response.errorMessage || 'Payment failed.' } };
		}

		if (options.ProductId) {
			return fetch(Urls.GooglePay.Confirmation, getFetchOptions('GET'))
			.then(function(confirmationResponse) {
				return confirmationResponse.text();
			})
			.then(function(text) {
				dialog.open({
					html: text,
					options: {
						dialogClass: 'pt_order-confirmation',
						open: function() {
							$('body').addClass('dialog-open');
							OrderConfirmation.init();
							var dataLayerOptions = {
								PaymentMethod: 'Google Pay'
							};
							$(document).off('click.OrderConfirmationModalClose').on('click.OrderConfirmationModalClose', '.ui-dialog.pt_order-confirmation .btn.continue', function(event) {
								event.preventDefault();
								dialog.close();
							});
							GoogleTagManagerClient.PushDataLayerForDataLayerType('ViewOrderConfirmation', null, dataLayerOptions).then(function() {
								$(document).trigger('ProductDetailPage.AddToCartOptionsSelect', { ProductId: $('#pid').val(), StoreId: $('.bopis-add-to-cart-options-container .selected-store').attr('store-id') });
							});
						},
						close: function(event, ui) {
							$('body').removeClass('dialog-open');
						}
					}
				});
				return { transactionState: 'SUCCESS' };
			});
		} else if (options.isCheckoutPage) {
			// Cart.Update's handler reads whichever _selectedPaymentMethodID radio is
			// currently checked and sends it to the server, which then overwrites the
			// session's selected payment method with it - without this, that radio is
			// still whatever it defaulted to (Credit Card), so the session reverts away
			// from Google Pay even though the instrument is correctly attached and the
			// balance is already $0. Mirrors billing.js's updatePaymentMethod().
			$('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
			$('input[value="DW_GOOGLE_PAY"]').prop('checked', 'checked');
			$(document).trigger('Cart.Update');
			return { transactionState: 'SUCCESS' };
		}

		window.location = Urls.onePage;
		return { transactionState: 'SUCCESS' };
	})
	.catch(function(error) {
		console.error('GooglePay-PaymentAuthorized', error);
		return { transactionState: 'ERROR', error: { intent: 'PAYMENT_AUTHORIZATION', reason: 'OTHER_ERROR', message: 'An unexpected error occurred.' } };
	});
}

var getPaymentRequestTimer;

function getGooglePayPaymentRequest(data) {
	// ProductDetailPage.Variant.Updated (and friends) can fire multiple times in quick
	// succession for a single user interaction; each call hits the server and touches
	// a temp basket, so debounce to collapse a burst into a single request and avoid
	// tripping platform rate limiting.
	clearTimeout(getPaymentRequestTimer);
	getPaymentRequestTimer = setTimeout(function() {
		fetchGooglePayPaymentRequest(getPdpPaymentRequestData(data));
	}, 300);
}

var paymentRequestSequence = 0;

function fetchGooglePayPaymentRequest(data) {
	// The button never shows on Apple Pay browsers, and building a temp basket there collides with Apple Pay's.
	if (isIosDevice || isSafariBrowser) {
		return;
	}

	// Cart.UpdateSuccess (shipping method, promo code, etc.) can fire more than once in quick
	// succession, each clearing/restarting the debounce above but still kicking off its own
	// independent fetch once it does fire - nothing stops two of those fetches from being in
	// flight at the same time, and responses aren't guaranteed to arrive in request order.
	// Without this guard, an older request's response landing after a newer one would silently
	// overwrite the buffer with stale data (wrong shippingAddressRequired/callbackIntents/etc.)
	// right before the shopper clicks the button.
	var thisRequestSequence = ++paymentRequestSequence;

	var urlSearchParameters = new URLSearchParams();
	if (data && data.ProductId) {
		urlSearchParameters.append('pid', data.ProductId);
		if (data.StoreId) {
			urlSearchParameters.append('storeid', data.StoreId);
		}
		var bopisAddToCartOption = $('.bopis-add-to-cart-options-container').find('input[name="AddToCartOption"]:checked').val();
		if (bopisAddToCartOption) {
			urlSearchParameters.append('addtocartoption', bopisAddToCartOption);
		}
	}
	if (options.isCheckoutPage) {
		// The shopper already entered a shipping/billing address earlier in this same
		// checkout flow - tells GetRequest to skip asking Google for its own copy and
		// use the one already on the basket instead (see GooglePay.js controller).
		urlSearchParameters.append('ischeckout', 'true');
	}

	fetch(Urls.GooglePay.GetRequest + (Array.from(urlSearchParameters).length ? '?' + urlSearchParameters : ''))
	.then(function(response) {
		if (!response.ok) {
			throw new Error('GetRequest failed with status ' + response.status);
		}
		return response.json();
	})
	.then(function(paymentDataRequest) {
		if (thisRequestSequence === paymentRequestSequence) {
			buffer['paymentDataRequest'] = paymentDataRequest;
		}
	})
	.catch(function(error) {
		// Don't leave a stale request from a previous product/variant sitting in the
		// buffer if this one failed - better to block the click than submit wrong data.
		if (thisRequestSequence === paymentRequestSequence) {
			delete buffer['paymentDataRequest'];
		}
		console.error('GooglePay-GetRequest', error);
	});
}

function getFetchOptions(method, body) {
	var fetchOptions = {
		credentials: 'include'
	};
	if (method) {
		fetchOptions.method = method;
	}
	if (body) {
		fetchOptions.headers = {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		}
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
}
